export enum LogLevels {
  passthrough = -1,
  error,
  warn,
  info,
  verbose,
  debug,
  silly
}
